export function ListItems(items, setItems, List) {

    List()
        .then((data) => {
            //console.log(data)
            setItems(data)
        })
        .catch(err => {
            //console.log(err.response)
        })
}